module.exports = __webpack_public_path__ + "img/20200108155911033.9abf9e1c.jpg";